import dynamic from 'next/dynamic';
import { useState } from 'react';

const Drawer = dynamic(() => import('./Drawer'), { ssr: false });
const DesktopModal = dynamic(() => import('./DesktopModal'), { ssr: false });

const CampaignModal = ({
  campaigns = [],
  onClose = () => {},
  onCtaClick = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen || !campaigns.length) return null;

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <>
      {/* Mobile: bottom sheet drawer */}
      <div className="lg:hidden">
        <Drawer
          campaigns={campaigns}
          onClose={handleClose}
          onCtaClick={onCtaClick}
        />
      </div>

      {/* Desktop: modal centralizado */}
      <div className="hidden lg:block">
        <DesktopModal
          campaigns={campaigns}
          onClose={handleClose}
          onCtaClick={onCtaClick}
        />
      </div>
    </>
  );
};

export default CampaignModal;
